import { useState } from "react";

const useModal = () => {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => setIsOpen(!isOpen);
	const open = () => setIsOpen(true);
	const close = () => setIsOpen(false);

	return { isOpen, toggle, open, close };
};

export default useModal;
